import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Autoplay, Navigation } from "swiper/modules";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

function Home() {
  const [berita, setBerita] = useState([]);
  const [userNum, setUserNum] = useState(0);
  const [accNum, setAccNum] = useState(0);
  const [belNum, setBelNum] = useState(0);
  const [corNum, setCorNum] = useState(0);

  // 🎯 Fetch berita dari API kamu
  useEffect(() => {
    fetch("https://api.rf-funserver.my.id/api/berita")
      .then((res) => res.json())
      .then((data) => setBerita(data))
      .catch(() => console.error("Gagal memuat berita"));
  }, []);

  // 🎯 Fetch total online dari server legacy (via Proxy Backend)
  useEffect(() => {
    fetch("https://api.rf-funserver.my.id/api/server-status-legacy")
      .then((res) => {
        if (!res.ok) throw new Error("API Network Error");
        return res.json();
      })
      .then((data) => {
        setUserNum(data.total || 0);
        setAccNum(data.acc || 0);
        setBelNum(data.bel || 0);
        setCorNum(data.cor || 0);
      })
      .catch((err) => {
        console.error("Gagal ambil data server:", err);
        // Set 0 jika gagal, jangan dummy 1530 lagi
        setUserNum(0);
        setAccNum(0);
        setBelNum(0);
        setCorNum(0);
      });
  }, []);


  return (
    <div className="bg-gradient-to-b from-black via-gray-900 to-gray-800 text-white">
      {/* 🎮 HERO SECTION */}
      <section className="relative h-[90vh]">
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          loop
          className="h-full"
        >
          {["reborn-banner1.jpg", "reborn-banner2.jpg"].map((img, i) => (
            <SwiperSlide key={i}>
              <div
                className="h-full w-full bg-cover bg-center flex items-center justify-center"
                style={{
                  backgroundImage: `url(/assets/${img})`,
                  backgroundBlendMode: "overlay",
                }}
              >
                <div className="bg-black/60 p-8 rounded-xl text-center max-w-3xl mx-auto">
                  <h1 className="text-5xl md:text-6xl font-extrabold text-orange-400 mb-4 tracking-wide drop-shadow-lg">
                    RF FUN REBORN
                  </h1>
                  <p className="text-lg md:text-xl text-gray-200">
                    Cap 81 • AOP 4.15 • Easy Farm • Autoloot • Nostalgia Full Power
                  </p>
                  <div className="mt-8 flex flex-wrap justify-center gap-4">
                    <a
                      href="/download"
                      className="bg-orange-600 hover:bg-orange-700 px-8 py-3 rounded-full font-semibold shadow-lg transition"
                    >
                      ⬇️ Download Client
                    </a>
                    <a
                      href="https://discord.gg/qFsPTq2Nwr"
                      className="bg-indigo-600 hover:bg-indigo-700 px-8 py-3 rounded-full font-semibold shadow-lg transition"
                    >
                      💬 Join Discord
                    </a>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      {/* 🔥 SERVER STATUS */}
      <section className="py-16 px-6 md:px-12 bg-gradient-to-b from-gray-900 to-black">
        <h2 className="text-3xl font-bold text-center text-orange-400 mb-10">
          🔥 Live Server Status
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 max-w-6xl mx-auto">
          <div className="bg-gray-800 p-6 text-center rounded-xl border border-purple-500 shadow-lg hover:scale-105 transition">
            <h3 className="text-lg font-bold mb-2">Login Server</h3>
            <p className="text-green-400 text-2xl font-semibold">Online</p>
          </div>

          <div className="bg-gray-800 p-6 text-center rounded-xl border border-purple-500 shadow-lg hover:scale-105 transition">
            <h3 className="text-lg font-bold mb-2">World Server</h3>
            <p className="text-green-400 text-2xl font-semibold">Online</p>
          </div>

          <div className="bg-gray-800 p-6 text-center rounded-xl border border-pink-500 shadow-lg hover:scale-105 transition">
            <h3 className="text-lg font-bold mb-2">Total Online</h3>
            <p className="text-yellow-400 text-4xl font-extrabold">{userNum}</p>
            <p className="text-sm text-gray-400">Players</p>
          </div>

          <div className="grid grid-cols-3 gap-2 col-span-1 sm:col-span-2 md:col-span-1">
            <div className="bg-red-800 p-4 rounded-xl border border-red-500 text-center hover:scale-105 transition">
              <img
                src="https://blackfunserver.my.id/assets/images/acc.png"
                className="h-8 w-8 mx-auto mb-2"
                alt="Accretia"
              />
              <h4 className="font-bold">ACC</h4>
              <p className="text-2xl font-extrabold">{accNum}</p>
            </div>
            <div className="bg-pink-800 p-4 rounded-xl border border-pink-500 text-center hover:scale-105 transition">
              <img src="https://blackfunserver.my.id/assets/images/bell.png" className="h-8 w-8 mx-auto mb-2"
                alt="Bellato"
              />
              <h4 className="font-bold">BEL</h4>
              <p className="text-2xl font-extrabold">{belNum}</p>
            </div>
            <div className="bg-blue-800 p-4 rounded-xl border border-blue-500 text-center hover:scale-105 transition">
              <img
                src="https://blackfunserver.my.id/assets/images/cora.png"
                className="h-8 w-8 mx-auto mb-2"
                alt="Cora"
              />
              <h4 className="font-bold">COR</h4>
              <p className="text-2xl font-extrabold">{corNum}</p>
            </div>
          </div>
        </div>
      </section>

      {/* 📰 BERITA & UPDATE */}
      <section className="py-16 px-6 md:px-12 bg-gray-950">
        <h2 className="text-3xl font-bold mb-10 text-center text-orange-400">
          📰 Berita & Update
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {berita.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="bg-gray-800 rounded-lg overflow-hidden border border-gray-700 hover:border-orange-400 transition"
            >
              <img
                src={item.thumbnail}
                alt={item.judul}
                className="h-48 w-full object-cover"
              />
              <div className="p-4">
                <h3 className="text-orange-400 font-semibold mb-2 text-lg">
                  {item.judul}
                </h3>
                <p className="text-sm text-gray-400 mb-3">{item.excerpt}</p>
                <a
                  href={`/blog/${item.slug}`}
                  className="text-orange-500 hover:text-orange-300 text-sm font-semibold"
                >
                  Baca Selengkapnya →
                </a>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <a
            href="/news"
            className="bg-orange-600 hover:bg-orange-700 px-6 py-3 rounded-full font-semibold shadow-lg transition"
          >
            Lihat Semua Berita
          </a>
        </div>
      </section>

      {/* ⚙️ FITUR UNGGULAN */}
      <section className="py-16 px-6 md:px-12 bg-gradient-to-b from-gray-900 to-black">
        <h2 className="text-3xl font-bold text-center text-orange-400 mb-12">
          ⚙️ Fitur Unggulan RF FUN REBORN
        </h2>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto text-center">
          <div className="bg-gray-800 p-8 rounded-lg border-t-4 border-orange-500 shadow-lg hover:shadow-orange-500/30 transition">
            <div className="text-4xl mb-4">🔥</div>
            <h4 className="text-xl font-semibold mb-2">Phoenix Economy</h4>
            <p className="text-gray-400 text-sm">
              Sistem ekonomi baru berbasis Phoenix Coin & Flame of Rebirth,
              membuat gameplay aktif & seimbang.
            </p>
          </div>

          <div className="bg-gray-800 p-8 rounded-lg border-t-4 border-blue-500 shadow-lg hover:shadow-blue-500/30 transition">
            <div className="text-4xl mb-4">⚔️</div>
            <h4 className="text-xl font-semibold mb-2">CAP Lv.81</h4>
            <p className="text-gray-400 text-sm">
              Full nostalgia namun tetap dinamis. Drop balance disesuaikan untuk
              player baru & veteran.
            </p>
          </div>

          <div className="bg-gray-800 p-8 rounded-lg border-t-4 border-red-500 shadow-lg hover:shadow-red-500/30 transition">
            <div className="text-4xl mb-4">🧠</div>
            <h4 className="text-xl font-semibold mb-2">Non-Benefit System</h4>
            <p className="text-gray-400 text-sm">
              Semua pemain berjuang dari bawah tanpa keunggulan donasi. Fair
              play, fun, dan kompetitif.
            </p>
          </div>
        </div>
      </section>

      {/* 🎥 GALLERY */}
      <section className="py-16 px-6 md:px-12 bg-gray-950">
        <h2 className="text-3xl font-bold text-center text-orange-400 mb-12">
          📸 Momen RF FUN REBORN
        </h2>
        <PhotoProvider>
          <Swiper
            modules={[Navigation]}
            navigation
            spaceBetween={16}
            slidesPerView={1}
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 4 },
            }}
            className="max-w-6xl mx-auto"
          >
            {[1, 2, 3, 4, 5, 6].map((id) => (
              <SwiperSlide key={id}>
                <PhotoView src={`/assets/gallery-${id}.png`}>
                  <img
                    src={`/assets/gallery-${id}.png`}
                    alt={`Reborn ${id}`}
                    className="w-full h-48 object-cover rounded-lg shadow-md hover:scale-105 transition cursor-pointer"
                  />
                </PhotoView>
              </SwiperSlide>
            ))}
          </Swiper>
        </PhotoProvider>
      </section>

      {/* 🚀 CTA */}
      <section className="py-16 text-center bg-gradient-to-b from-black to-[#0b0c10] border-t border-orange-500">

        <h2 className="text-4xl font-extrabold mb-6 text-orange-400">
          Siap Kembali ke Medan Perang?
        </h2>
        <p className="text-gray-300 mb-8">
          Rasakan kembali dunia klasik RF dengan semangat baru, sistem modern,
          dan komunitas aktif setiap hari.
        </p>
        <a
          href="/download"
          className="bg-orange-600 hover:bg-orange-700 px-10 py-4 rounded-full font-bold text-white shadow-lg transition"
        >
          🚀 Mulai Sekarang
        </a>
      </section>
    </div>
  );
}

export default Home;
